import { createFileRoute } from '@tanstack/react-router';
import { installedAppsQueryOptions } from '@/api/queries/useInstalledApps';
import { findInstalledApp } from '@/lib/app-registry';
import { resolveAppTitle } from '@/lib/app-loader';
import { AppHostPage } from '@/components/app-host/AppHostPage';
import i18next from '@/lib/i18n';

/**
 * Apps inside a partner tenant (SALES-68: the sales app is the first). The
 * same host as `/$slug/apps/$`, inside the partner layout.
 */
export const Route = createFileRoute('/partner/apps/$')({
  loader: async ({ params, context }) => {
    const appId = params._splat?.split('/')[0] ?? '';
    let fallbackLabel;
    try {
      const apps = await context.queryClient.ensureQueryData(installedAppsQueryOptions);
      fallbackLabel = findInstalledApp(apps, appId)?.routes[0]?.label;
    } catch {
      /* fall through — resolveAppTitle uses appId as last resort */
    }
    return {
      breadcrumb: resolveAppTitle(appId, fallbackLabel, i18next.language),
      // App-internal navigation lives entirely in search params, so the app
      // crumb doubles as a link back to the app's start page.
      breadcrumbClearsSearch: true
    };
  },
  component: PartnerAppRoute
});

function PartnerAppRoute() {
  const { _splat } = Route.useParams();
  const appId = _splat?.split('/')[0] ?? '';
  return <AppHostPage appId={appId} />;
}
